import Contractor from '@Contractors/views/Contractor.vue';
import permissions from '@Share/config/permissions';

export default [
  {
    path: '/manage-contractors',
    name: 'contractor',
    component: Contractor,
    meta: {
      requiresAuth: true,
      layout: 'accountLayout',
      title: 'Contractor',
      permissions: [permissions.Contractors.View],
    },
  },
];
